/*************************************************************
  Copyright (c) 2013 Microsoft Corporation
**************************************************************/
// NOTE: For compilation, %target%\usage\TypeScriptUsageTypes.ts is needed. Include it before this file.
//       It is generated from otools/osfclient/inc/UsageSchema.xml, and contains the declaration for OSFLog.
// ambient declaration for ULS module
declare var Diag;
// ambient declaration
module Telemetry {
  "use strict";
  export enum ULSTraceLevel {
    unexpected = 10,
    warning = 15,
    info = 50,
    verbose = 100,
    verboseEx = 200,
  }
  export enum ULSCat {
    msoulscat_Osf_Latency = 1401,
    msoulscat_Osf_Notification = 1402,
    msoulscat_Osf_Runtime = 1403,
    msoulscat_Osf_AppManagementMenu = 1404,
    msoulscat_Osf_InsertionDialogSession = 1405,
    msoulscat_Osf_UploadFileDevCatelog = 1406,
    msoulscat_Osf_UploadFileDevCatalogUsage = 1411,
  }
  /// <summary>
  /// Bit masks for telemetry flags
  /// </summary>
  enum AppManagementMenuFlags {
    ConfirmationDialogCancel = 0x100,
    InsertionDialogClosed = 0x200,
    IsAnonymous = 0x400,
  }
  enum InsertionDialogStateFlags {
    Undefined = 0x0,
    Inserted = 0x1,
    Canceled = 0x2,
    Closed = 0x3,
    TrustPageVisited = 0x8,
  }
  export class LatencyStopwatch {
    private timeValue: number = 0;
    private finishedMeasurement: boolean;
    constructor() {}
    public Start() {
      this.timeValue = -new Date().getTime();
      this.finishedMeasurement = false;
    }
    public Stop() {
      if (this.timeValue < 0) {
        this.timeValue += new Date().getTime();
        this.finishedMeasurement = true;
      }
    }
    public get Finished(): boolean {
      return this.finishedMeasurement;
    }
    /// <summary>
    /// This returns the current elapsed time for the stopwatch.  If the timer has completed, this will
    /// be a positive value representing milliseconds that the timer was active.  If the timer has not called Stop()
    /// then a negative value will be returned, representing the time since the timer was started.
    /// </summary>
    public get ElapsedTime(): number {
      var elapsedTime = this.timeValue;
      if (!this.Finished && elapsedTime < 0) {
        // If time measurement has no finished yet, return a negative value indicating elapsed time
        elapsedTime = Math.abs(elapsedTime) - new Date().getTime();
      }
      return elapsedTime;
    }
  }
  export class Context {
    LoadTime: OSFLog.AppLoadTimeUsageData;
    Timers: {
      [name: string]: LatencyStopwatch;
    };
    AppStatus: string;
    ActivationRuntimeType: number;
  }
  export class Logger {
    private static s_externalLogger: any = null;
    static SetExternalLogger(extLogger: any) {
      Logger.s_externalLogger = extLogger;
    }

    static SendULSTraceTag(category: number, level: number, data: string, tagId: number) {
      // Check if ULS is enabled or not
      // @ts-ignore TS2339
      if (!Microsoft.Office.WebExtension.FULSSupported) {
        return;
      }
      // Try to use default ULS logger, then use the provided external logger
      if ((<any>window).Diag && Diag.UULS && Diag.UULS.trace) {
        Diag.UULS.trace(tagId, category, level, data);
      } else if (Logger.s_externalLogger && Logger.s_externalLogger.sendTraceTag) {
        Logger.s_externalLogger.sendTraceTag(tagId, category, level, data);
      }
    }
  }
  export class NotificationLogger implements OSFLog.IUsageLogger {
    private static instance: NotificationLogger;
    private static category: number = ULSCat.msoulscat_Osf_Notification;
    private static level: number = ULSTraceLevel.info;
    constructor() {}
    public static Instance(): NotificationLogger {
      if (!NotificationLogger.instance) {
        NotificationLogger.instance = new NotificationLogger();
      }
      return NotificationLogger.instance;
    }
    public LogData(data: OSFLog.IUsageData) {
      // Preserve current tag from osfclient, telemetry scripts depend on this tag
      // ASSERTTAG_IGNORE_START
      Logger.SendULSTraceTag(
        NotificationLogger.category,
        NotificationLogger.level,
        data.SerializeRow(),
        0x005c815f /* tag_axif5 */,
      );
      // ASSERTTAG_IGNORE_FINISH
    }
  }
  export class AppManagementMenuLogger implements OSFLog.IUsageLogger {
    private static instance: AppManagementMenuLogger;
    private static category: number = ULSCat.msoulscat_Osf_AppManagementMenu;
    private static level: number = ULSTraceLevel.info;
    constructor() {}
    public static Instance(): NotificationLogger {
      if (!AppManagementMenuLogger.instance) {
        AppManagementMenuLogger.instance = new AppManagementMenuLogger();
      }
      return AppManagementMenuLogger.instance;
    }
    public LogData(data: OSFLog.IUsageData) {
      Logger.SendULSTraceTag(
        AppManagementMenuLogger.category,
        AppManagementMenuLogger.level,
        data.SerializeRow(),
        0x1f31d7e1 /* tag_5m357 */,
      );
    }
  }
  export class UploadFileDevCatelogLogger implements OSFLog.IUsageLogger {
    private static instance: UploadFileDevCatelogLogger;
    private static category: number = ULSCat.msoulscat_Osf_UploadFileDevCatelog;
    private static level: number = ULSTraceLevel.info;
    constructor() {}
    public static Instance(): UploadFileDevCatelogLogger {
      if (!UploadFileDevCatelogLogger.instance) {
        UploadFileDevCatelogLogger.instance = new UploadFileDevCatelogLogger();
      }
      return UploadFileDevCatelogLogger.instance;
    }
    public LogData(data: OSFLog.IUsageData) {
      Logger.SendULSTraceTag(
        UploadFileDevCatelogLogger.category,
        UploadFileDevCatelogLogger.level,
        data.SerializeRow(),
        0x1f31d7e2 /* tag_5m358 */,
      );
    }
  }
  export class UploadFileDevCatalogUsageLogger implements OSFLog.IUsageLogger {
    private static instance: UploadFileDevCatalogUsageLogger;
    private static category: number = ULSCat.msoulscat_Osf_UploadFileDevCatalogUsage;
    private static level: number = ULSTraceLevel.info;
    constructor() {}
    public static Instance(): UploadFileDevCatalogUsageLogger {
      if (!UploadFileDevCatalogUsageLogger.instance) {
        UploadFileDevCatalogUsageLogger.instance = new UploadFileDevCatalogUsageLogger();
      }
      return UploadFileDevCatalogUsageLogger.instance;
    }
    public LogData(data: OSFLog.IUsageData) {
      Logger.SendULSTraceTag(
        UploadFileDevCatalogUsageLogger.category,
        UploadFileDevCatalogUsageLogger.level,
        data.SerializeRow(),
        0x1f31d7e3 /* tag_5m359 */,
      );
    }
  }
  export class LatencyLogger implements OSFLog.IUsageLogger {
    private static instance: LatencyLogger;
    private static category: number = ULSCat.msoulscat_Osf_Latency;
    private static level: number = ULSTraceLevel.info;
    constructor() {}
    public static Instance(): LatencyLogger {
      if (!LatencyLogger.instance) {
        LatencyLogger.instance = new LatencyLogger();
      }
      return LatencyLogger.instance;
    }
    public LogData(data: OSFLog.IUsageData) {
      // Preserve current tag from osfclient, telemetry scripts depend on this tag
      // ASSERTTAG_IGNORE_START
      Logger.SendULSTraceTag(
        LatencyLogger.category,
        LatencyLogger.level,
        data.SerializeRow(),
        0x00487317 /* tag_ashmx */,
      );
      // ASSERTTAG_IGNORE_FINISH
    }
  }
  export class InsertionDialogSessionLogger implements OSFLog.IUsageLogger {
    private static instance: InsertionDialogSessionLogger;
    private static category: number = ULSCat.msoulscat_Osf_InsertionDialogSession;
    private static level: number = ULSTraceLevel.info;
    constructor() {}
    public static Instance(): InsertionDialogSessionLogger {
      if (!InsertionDialogSessionLogger.instance) {
        InsertionDialogSessionLogger.instance = new InsertionDialogSessionLogger();
      }
      return InsertionDialogSessionLogger.instance;
    }
    public LogData(data: OSFLog.IUsageData) {
      Logger.SendULSTraceTag(
        InsertionDialogSessionLogger.category,
        InsertionDialogSessionLogger.level,
        data.SerializeRow(),
        0x1f31d800 /* tag_5m36a */,
      );
    }
  }
  export class AppNotificationHelper {
    public static LogNotification(correlationId: string, errorResult: number, notificationClickInfo: number) {
      var notificationData = new OSFLog.AppNotificationUsageData();
      notificationData.CorrelationId = correlationId;
      notificationData.ErrorResult = errorResult;
      notificationData.NotificationClickInfo = notificationClickInfo;
      NotificationLogger.Instance().LogData(notificationData);
    }
  }
  export class AppManagementMenuHelper {
    public static LogAppManagementMenuAction(
      assetId: string,
      operationMetadata: number,
      untrustedCount: number,
      isDialogClosed: boolean,
      isAnonymous: boolean,
      hrStatus: number,
    ) {
      var appManagementMenuData = new OSFLog.AppManagementMenuUsageData();
      var assetIdNumber =
        assetId.toLowerCase().indexOf("wa") === 0 ? parseInt(assetId.substring(2), 10) : parseInt(assetId, 10);
      if (isDialogClosed) {
        operationMetadata |= AppManagementMenuFlags.InsertionDialogClosed;
      }
      if (isAnonymous) {
        operationMetadata |= AppManagementMenuFlags.IsAnonymous;
      }
      appManagementMenuData.AssetId = assetIdNumber;
      appManagementMenuData.OperationMetadata = operationMetadata;
      appManagementMenuData.ErrorResult = hrStatus;
      AppManagementMenuLogger.Instance().LogData(appManagementMenuData);
    }
  }
  export class UploadFileDevCatelogHelper {
    public static LogUploadFileDevCatelogAction(
      correlationId: string,
      operationMetadata: number,
      untrustedCount: number,
      isDialogClosed: boolean,
      isAnonymous: boolean,
      hrStatus: number,
    ) {
      var uploadFileDevCatelogData = new OSFLog.UploadFileDevCatelogUsageData();
      uploadFileDevCatelogData.CorrelationId = correlationId;
      uploadFileDevCatelogData.OperationMetadata = operationMetadata;
      uploadFileDevCatelogData.ErrorResult = hrStatus;
      UploadFileDevCatelogLogger.Instance().LogData(uploadFileDevCatelogData);
    }
  }
  export class UploadFileDevCatalogUsageHelper {
    public static LogUploadFileDevCatalogUsageAction(
      correlationId: string,
      storeType: string,
      id: string,
      appVersion: string,
      appTargetType: number,
      isAppCommand: string,
      appSizeWidth: number,
      appSizeHeight: number,
    ) {
      var uploadFileDevCatalogUsageData = new OSFLog.UploadFileDevCatalogUsageUsageData();
      uploadFileDevCatalogUsageData.CorrelationId = correlationId;
      uploadFileDevCatalogUsageData.StoreType = storeType;
      uploadFileDevCatalogUsageData.AppId = id;
      uploadFileDevCatalogUsageData.AppVersion = appVersion;
      uploadFileDevCatalogUsageData.AppTargetType = appTargetType;
      uploadFileDevCatalogUsageData.IsAppCommand = isAppCommand;
      uploadFileDevCatalogUsageData.AppSizeWidth = appSizeWidth;
      uploadFileDevCatalogUsageData.AppSizeHeight = appSizeHeight;
      UploadFileDevCatalogUsageLogger.Instance().LogData(uploadFileDevCatalogUsageData);
    }
  }
  export class AppLoadTimeHelper {
    // Number of apps being activated simultaneously
    private static activatingNumber: number = 0;
    private static GenerateActivationMessage(activationRuntimeType: number, correlationId: string): string {
      var message: string = "";
      if (activationRuntimeType != null) {
        message += "ActivationRuntimeType: " + activationRuntimeType.toString() + "|";
      }
      if (correlationId != null) {
        message += "CorrelationId: " + correlationId;
      }
      return message;
    }
    public static ActivationStart(
      context: Context,
      appInfo: number,
      assetId: number,
      correlationId: string,
      instanceId: string,
      runtimeType: number,
    ) {
      AppLoadTimeHelper.activatingNumber++;
      context.LoadTime = new OSFLog.AppLoadTimeUsageData();
      context.Timers = {};
      context.LoadTime.CorrelationId = correlationId;
      context.LoadTime.AppInfo = appInfo;
      context.LoadTime.ActivationInfo = 0;
      context.LoadTime.InstanceId = instanceId;
      context.LoadTime.AssetId = assetId;
      context.LoadTime.Stage1Time = 0;
      context.Timers["Stage1Time"] = new LatencyStopwatch();
      context.LoadTime.Stage2Time = 0;
      context.Timers["Stage2Time"] = new LatencyStopwatch();
      // sandbox creatation time isn't logged on WAC
      context.LoadTime.Stage3Time = 0;
      context.LoadTime.Stage4Time = 0;
      context.Timers["Stage4Time"] = new LatencyStopwatch();
      context.LoadTime.Stage5Time = 0;
      context.Timers["Stage5Time"] = new LatencyStopwatch();
      context.LoadTime.Stage6Time = AppLoadTimeHelper.activatingNumber;
      context.LoadTime.Stage7Time = 0;
      context.Timers["Stage7Time"] = new LatencyStopwatch();
      context.LoadTime.Stage8Time = 0;
      context.Timers["Stage8Time"] = new LatencyStopwatch();
      context.LoadTime.Stage9Time = 0;
      context.Timers["Stage9Time"] = new LatencyStopwatch();
      context.LoadTime.Stage10Time = 0;
      context.Timers["Stage10Time"] = new LatencyStopwatch();
      context.LoadTime.Stage11Time = 0;
      context.Timers["Stage11Time"] = new LatencyStopwatch();
      context.LoadTime.ErrorResult = 0;
      context.ActivationRuntimeType = runtimeType;
      AppLoadTimeHelper.StartStopwatch(context, "Stage1Time");
      Logger.SendULSTraceTag(
        ULSCat.msoulscat_Osf_Runtime,
        ULSTraceLevel.info,
        AppLoadTimeHelper.GenerateActivationMessage(runtimeType, correlationId),
        0x1f31d801 /* tag_5m36b */,
      );
    }
    public static ActivationEnd(context: Context) {
      AppLoadTimeHelper.ActivateEndInternal(context);
    }
    public static PageStart(context: Context) {
      AppLoadTimeHelper.StartStopwatch(context, "Stage2Time");
    }
    public static PageLoaded(context: Context) {
      AppLoadTimeHelper.StopStopwatch(context, "Stage2Time");
    }
    public static ServerCallStart(context: Context) {
      AppLoadTimeHelper.StartStopwatch(context, "Stage4Time");
    }
    public static ServerCallEnd(context: Context) {
      AppLoadTimeHelper.StopStopwatch(context, "Stage4Time");
    }
    public static AuthenticationStart(context: Context) {
      AppLoadTimeHelper.StartStopwatch(context, "Stage5Time");
    }
    public static AuthenticationEnd(context: Context) {
      AppLoadTimeHelper.StopStopwatch(context, "Stage5Time");
    }
    public static EntitlementCheckStart(context: Context) {
      AppLoadTimeHelper.StartStopwatch(context, "Stage7Time");
    }
    public static EntitlementCheckEnd(context: Context) {
      AppLoadTimeHelper.StopStopwatch(context, "Stage7Time");
    }
    public static KilledAppsCheckStart(context: Context) {
      AppLoadTimeHelper.StartStopwatch(context, "Stage8Time");
    }
    public static KilledAppsCheckEnd(context: Context) {
      AppLoadTimeHelper.StopStopwatch(context, "Stage8Time");
    }
    public static AppStateCheckStart(context: Context) {
      AppLoadTimeHelper.StartStopwatch(context, "Stage9Time");
    }
    public static AppStateCheckEnd(context: Context) {
      AppLoadTimeHelper.StopStopwatch(context, "Stage9Time");
    }
    public static ManifestRequestStart(context: Context) {
      AppLoadTimeHelper.StartStopwatch(context, "Stage10Time");
    }
    public static ManifestRequestEnd(context: Context) {
      AppLoadTimeHelper.StopStopwatch(context, "Stage10Time");
    }
    public static OfficeJSStartToLoad(context: Context) {
      AppLoadTimeHelper.StartStopwatch(context, "Stage11Time");
    }
    public static OfficeJSLoaded(context: Context) {
      AppLoadTimeHelper.StopStopwatch(context, "Stage11Time");
    }
    public static SetAnonymousFlag(context: Context, anonymousFlag: boolean) {
      AppLoadTimeHelper.SetActivationInfoField(context, AppLoadTimeHelper.ConvertFlagToBit(anonymousFlag), 2, 0);
    }
    public static SetRetryCount(context: Context, retryCount: number) {
      AppLoadTimeHelper.SetActivationInfoField(context, retryCount, 3, 2);
    }
    public static SetManifestTrustCachedFlag(context: Context, manifestTrustCachedFlag: boolean) {
      AppLoadTimeHelper.SetActivationInfoField(
        context,
        AppLoadTimeHelper.ConvertFlagToBit(manifestTrustCachedFlag),
        2,
        5,
      );
    }
    public static SetManifestDataCachedFlag(context: Context, manifestDataCachedFlag: boolean) {
      AppLoadTimeHelper.SetActivationInfoField(
        context,
        AppLoadTimeHelper.ConvertFlagToBit(manifestDataCachedFlag),
        2,
        7,
      );
    }
    public static SetOmexHasEntitlementFlag(context: Context, omexHasEntitlementFlag: boolean) {
      AppLoadTimeHelper.SetActivationInfoField(
        context,
        AppLoadTimeHelper.ConvertFlagToBit(omexHasEntitlementFlag),
        2,
        9,
      );
    }
    public static SetManifestDataInvalidFlag(context: Context, manifestDataInvalidFlag: boolean) {
      AppLoadTimeHelper.SetActivationInfoField(
        context,
        AppLoadTimeHelper.ConvertFlagToBit(manifestDataInvalidFlag),
        2,
        11,
      );
    }
    public static SetAppStateDataCachedFlag(context: Context, appStateDataCachedFlag: boolean) {
      AppLoadTimeHelper.SetActivationInfoField(
        context,
        AppLoadTimeHelper.ConvertFlagToBit(appStateDataCachedFlag),
        2,
        13,
      );
    }
    public static SetAppStateDataInvalidFlag(context: Context, appStateDataInvalidFlag: boolean) {
      AppLoadTimeHelper.SetActivationInfoField(
        context,
        AppLoadTimeHelper.ConvertFlagToBit(appStateDataInvalidFlag),
        2,
        15,
      );
    }
    public static SetActivationRuntimeType(context: Context, activationRuntimeType: number) {
      AppLoadTimeHelper.SetActivationInfoField(context, activationRuntimeType, 2, 17);
    }
    public static SetErrorResult(context: Context, result: number) {
      if (context.LoadTime) {
        context.LoadTime.ErrorResult = result;
        AppLoadTimeHelper.ActivateEndInternal(context);
      }
    }
    public static SetBit(context: Context, value: number, offset: number, length?: number) {
      AppLoadTimeHelper.SetActivationInfoField(context, value, length || 2, offset);
    }
    public static StartStopwatch(context: Context, name: string) {
      if (context.LoadTime && context.Timers && context.Timers[name]) {
        context.Timers[name].Start();
        AppLoadTimeHelper.UpdateActivatingNumber(context);
      }
    }
    public static StopStopwatch(context: Context, name: string) {
      if (context.LoadTime && context.Timers && context.Timers[name]) {
        context.Timers[name].Stop();
        AppLoadTimeHelper.UpdateActivatingNumber(context);
      }
    }
    /// <summary>
    /// Returns 2 if true, or 1 if false.  0 Represents the value where we have not set the field yet.
    /// </summary>
    private static ConvertFlagToBit(flag: boolean): number {
      if (flag) {
        return 2;
      } else {
        return 1;
      }
    }
    private static SetActivationInfoField(context: Context, value: number, length: number, offset: number) {
      if (context.LoadTime) {
        AppLoadTimeHelper.UpdateActivatingNumber(context);
        context.LoadTime.ActivationInfo = AppLoadTimeHelper.SetBitField(
          context.LoadTime.ActivationInfo,
          value,
          length,
          offset,
        );
      }
    }
    private static SetBitField(field: number, value: number, length: number, offset: number): number {
      var mask = (Math.pow(2, length) - 1) << offset;
      // Set the field bits to 0 in case the value was previously set
      var cleanField = field & ~mask;
      return cleanField | (value << offset);
    }
    private static UpdateActivatingNumber(context: Context) {
      if (context.LoadTime) {
        // To simplify the logical, just keep maximum number
        context.LoadTime.Stage6Time =
          context.LoadTime.Stage6Time > AppLoadTimeHelper.activatingNumber
            ? context.LoadTime.Stage6Time
            : AppLoadTimeHelper.activatingNumber;
      }
    }
    private static ActivateEndInternal(context: Context) {
      if (context.LoadTime) {
        AppLoadTimeHelper.StopStopwatch(context, "Stage1Time");
        // Update the stage times based on the stopwatches elapsed time
        if (context.Timers) {
          for (var key in context.Timers) {
            if (context.Timers[key].ElapsedTime != null) {
              // ElapsedTime is a positive value if the timer scope was successful in reaching the end.
              // This will be a negative value if Stop() was never called on the timer, letting the data show something went wrong in this scope and the amount of time it took to fail.
              context.LoadTime[key] = context.Timers[key].ElapsedTime;
            }
          }
        }
        Logger.SendULSTraceTag(
          ULSCat.msoulscat_Osf_Runtime,
          ULSTraceLevel.info,
          AppLoadTimeHelper.GenerateActivationMessage(context.ActivationRuntimeType, context.LoadTime.CorrelationId),
          0x1f31d802 /* tag_5m36c */,
        );
        LatencyLogger.Instance().LogData(context.LoadTime);
        context.LoadTime = null;
        AppLoadTimeHelper.activatingNumber--;
      }
    }
  }
  export class RuntimeTelemetryHelper {
    private static category: number = ULSCat.msoulscat_Osf_Runtime;
    public static LogProxyFailure(
      appCorrelationId: string,
      methodName: string,
      errorInfo: {
        [id: string]: any;
      },
    ) {
      var constructedMessage: string;
      if (appCorrelationId == null) {
        appCorrelationId = "";
      }
      constructedMessage = OSF.OUtil.formatString("appCorrelationId:{0}, methodName:{1}", appCorrelationId, methodName);
      Object.keys(errorInfo).forEach(function (key) {
        var value = errorInfo[key];
        if (value != null) {
          value = value.toString();
        }
        constructedMessage += ", " + key + ":" + value;
      });

      // usually constructedMessage looks like: appCorrelationId:[object Object], methodName:OMEX_getAuthNStatus, statusCode:404, tagId:6095312, url:UREDACTED_(yEc5+sumU/BcsFUNzxdTVdqsr5/4hmf0A2aJIfcXTKE=), result:3
      let logWarning = true;
      const statusCodePattern: RegExp = new RegExp("statusCode:(\\d+)");
      let match: any | undefined = constructedMessage.match(statusCodePattern);
      if (match) {
        switch (match[1]) {
          case "404":
            logWarning = false;
            Logger.SendULSTraceTag(
              RuntimeTelemetryHelper.category,
              ULSTraceLevel.info,
              constructedMessage,
              0x1e420558 /* tag_4q6vy */,
            );
            break;
          default:
            logWarning = true;
            break;
        }
      }
      if (logWarning) {
        // Preserve current tag from osfclient, telemetry scripts depend on this tag
        // ASSERTTAG_IGNORE_START
        Logger.SendULSTraceTag(
          RuntimeTelemetryHelper.category,
          ULSTraceLevel.warning,
          constructedMessage,
          0x005c8160 /* tag_axif6 */,
        );
        // ASSERTTAG_IGNORE_FINISH
      }
    }
    public static LogExceptionTag(message: string, exception: any, appCorrelationId: string, tagId: number) {
      var constructedMessage: string = message;
      if (exception) {
        if (exception.name) {
          constructedMessage += " Exception name:" + exception.name + ".";
        }
        if (exception.paramName) {
          constructedMessage += " Param name:" + exception.paramName + ".";
        }
        if (exception.message) {
          constructedMessage += " Message:" + exception.message + ".";
        }
        if (exception.stack) {
          constructedMessage += " [Stack:" + exception.stack + "]";
        }
      }
      if (appCorrelationId != null) {
        constructedMessage += " AppCorrelationId:" + appCorrelationId + ".";
      }
      // ASSERTTAG_IGNORE_START
      Logger.SendULSTraceTag(RuntimeTelemetryHelper.category, ULSTraceLevel.warning, constructedMessage, tagId);
      // ASSERTTAG_IGNORE_FINISH
    }
    public static LogCommonMessageTag(message: string, appCorrelationId: string, tagId: number) {
      if (appCorrelationId != null) {
        message += " AppCorrelationId:" + appCorrelationId + ".";
      }
      // ASSERTTAG_IGNORE_START
      Logger.SendULSTraceTag(RuntimeTelemetryHelper.category, ULSTraceLevel.info, message, tagId);
      // ASSERTTAG_IGNORE_FINISH
    }
  }
  export class InsertionDialogSessionHelper {
    public static LogInsertionDialogSession(
      assetId: string,
      totalSessionTime: number,
      trustPageSessionTime: number,
      appInserted: boolean,
      lastActiveTab: number,
      lastActiveTabCount: number,
    ) {
      var insertionDialogSessionData = new OSFLog.InsertionDialogSessionUsageData();
      var assetIdNumber =
        assetId.toLowerCase().indexOf("wa") === 0 ? parseInt(assetId.substring(2), 10) : parseInt(assetId, 10);
      var dialogState = InsertionDialogStateFlags.Undefined;
      if (appInserted) {
        dialogState |= InsertionDialogStateFlags.Inserted;
      } else {
        dialogState |= InsertionDialogStateFlags.Canceled;
      }
      if (trustPageSessionTime > 0) {
        dialogState |= InsertionDialogStateFlags.TrustPageVisited;
      }
      insertionDialogSessionData.AssetId = assetIdNumber;
      insertionDialogSessionData.TotalSessionTime = totalSessionTime;
      insertionDialogSessionData.TrustPageSessionTime = trustPageSessionTime;
      insertionDialogSessionData.DialogState = dialogState;
      insertionDialogSessionData.LastActiveTab = lastActiveTab;
      insertionDialogSessionData.LastActiveTabCount = lastActiveTabCount;
      InsertionDialogSessionLogger.Instance().LogData(insertionDialogSessionData);
    }
  }
  //Telemetry.PrivacyRules
  //Contains rules for logging customer add-in content
  export class PrivacyRules {
    private static readonly privateCompliantId = "PRIVATE"; //In the event we cannot log the solutionId we will instead log this string
    /// <summary>
    /// Logic to determine if we should log the add-in's assetId.
    /// </summary>
    public static IsPrivateAddin(
      storeType: string,
      assetId: string,
      exchangeExtensionProviderName?: string,
      exchangeExtensionType?: string,
      storeId?: string,
    ) {
      switch ((storeType || "").toLowerCase()) {
        case OSF.StoreType.OMEX:
        case OSF.StoreType.HardCodedPreinstall:
        case OSF.StoreType.FirstParty:
        case OSF.StoreType.Sdx:
        case OSF.StoreType.WopiCatalog: // WOPICatalog only contains Omex and is safe to be public.
          return false;

        case OSF.StoreType.SPCatalog:
        case OSF.StoreType.SPApp:
        case OSF.StoreType.FileSystem:
        case OSF.StoreType.Registry:
        case OSF.StoreType.UploadFileDevCatalog:
        case OSF.StoreType.MosExtra:
          return true;

        case OSF.StoreType.PrivateCatalog: {
          // Check if assetId is set and it belongs to Omex
          if (assetId && assetId.toLowerCase().indexOf("wa") === 0) {
            return false;
          }

          return true;
        }

        case OSF.StoreType.Exchange: {
          var extensionTypeLowerCase = exchangeExtensionType != null ? exchangeExtensionType.toLowerCase() : null;
          if (
            (extensionTypeLowerCase && extensionTypeLowerCase === "default") ||
            extensionTypeLowerCase === "marketplace" ||
            extensionTypeLowerCase === "preinstalled" ||
            extensionTypeLowerCase === "marketplaceprivatecatalog"
          ) {
            return false;
          }

          var providerNameLowercase =
            exchangeExtensionProviderName != null ? exchangeExtensionProviderName.toLowerCase() : null;
          if (
            (providerNameLowercase && providerNameLowercase === "microsoft") ||
            providerNameLowercase === "microsoft corp" ||
            providerNameLowercase === "microsoft corp." ||
            providerNameLowercase === "microsoft corporation"
          ) {
            return false;
          }
          return true;
        }

        // InMemory is for AppCommands. Callers should not pass in InMemory but should instead use the OwnerStoreType.
        case OSF.StoreType.InMemory:
        default:
          Logger.SendULSTraceTag(
            ULSCat.msoulscat_Osf_Notification,
            ULSTraceLevel.warning,
            "Unknown StoreType: " + storeType + " in function IsPrivateAddin.",
            0x1f31d803 /* tag_5m36d */,
          );
          return true;
      }
    }

    /// <summary>
    /// A helper function that uses IsPrivateAddin to directly get the string that should be logged.
    ///  If we cannot log the assetId the value of privateCompliantId is logged in its place.
    /// </summary>
    public static GetAssetId(
      storeType: string,
      storeId: string,
      assetId: string,
      exchangeExtensionProviderName?: string,
      exchangeExtensionType?: string,
    ) {
      // Feature 5311421: GetAssetId is deprecated and replaced by GetPrivacyCompliantId
      // 1/1/2023 - OWA has updated to GetPrivacyCompliantId under a flight. After OWAflight is graduated  confirm
      //  no calls made to GetAssetId in WXPO clients and then remove the GetAssetid method.

      // log any calls to GetAssetId to ensure no callers before removing GetAssetid method. Can check for occurances of tag to ensure no callers.
      Telemetry.RuntimeTelemetryHelper.LogExceptionTag(
        "PrivacyRules GetAssetId is deprecated",
        null,
        null,
        0x1e60e595 /* tag_4yowv */,
      );

      return PrivacyRules.IsPrivateAddin(
        storeType,
        assetId,
        exchangeExtensionProviderName,
        exchangeExtensionType,
        storeId,
      )
        ? PrivacyRules.privateCompliantId
        : assetId;
    }

    /// <summary>
    /// A helper function that uses IsPrivateAddin to directly get the string that should be logged.
    ///  If we cannot log the compliantID the value of a privateId is logged in its place.
    /// </summary>
    public static GetPrivacyCompliantId(
      solutionId: string,
      storeType: string,
      assetId: string,
      exchangeExtensionProviderName?: string,
      exchangeExtensionType?: string,
      storeId?: string,
    ): string {
      return PrivacyRules.IsPrivateAddin(
        storeType,
        assetId,
        exchangeExtensionProviderName,
        exchangeExtensionType,
        storeId,
      )
        ? PrivacyRules.privateCompliantId
        : solutionId;
    }
  }
}
